import axios from "axios";

export default axios.create({
  baseURL: "https://api.testb19.be/admin",
  headers: {
    "Content-type": "application/json"
  }
});
